import { useCallback, useMemo } from 'react';
import { useCampaignShopifyConfig, useCampaignShopifyCreators } from './useCampaignShopify';

/**
 * Per-creator "has no live discount code" lookup for roster surfaces. Reports
 * a creator as code-less only once both the config and the creator list have
 * loaded successfully, so loading and error never read as "no code".
 */
export function useCreatorCodeStatus(campaignId: string, enabled = true) {
  const config = useCampaignShopifyConfig(enabled ? campaignId : '');
  const perCreator =
    enabled &&
    config.isSuccess &&
    !!config.data?.enabled &&
    config.data.mode === 'per_creator';
  const creators = useCampaignShopifyCreators(campaignId, '', perCreator);

  const withoutCode = useMemo(() => {
    const ids = new Set<string>();
    if (!perCreator || !creators.isSuccess) return ids;
    for (const c of creators.data ?? []) {
      if (!c.has_coupon) ids.add(c.roster_entry_id);
    }
    return ids;
  }, [perCreator, creators.isSuccess, creators.data]);

  const hasNoCode = useCallback((rosterEntryId: string) => withoutCode.has(rosterEntryId), [withoutCode]);

  return { hasNoCode };
}
